import { useState, useEffect } from 'react';
import { 
    DatePicker, 
    Space,
    Input,
} from 'antd';
import locale from 'antd/es/date-picker/locale/ru_RU';
import dayjs from 'dayjs';
import dayjsLocale from 'dayjs/locale/ru';
import objectSupport from 'dayjs/plugin/objectSupport';

import References from '../../helpers/Reference';
import {ShowLocaleDate, ConvertToDatepickerDate, GetSeason, FormatDateBySeason, GetDecade, GetStepMonth, FormatDateByDecade, FormatDateByMonth, FormatDateByYear  } from '../../helpers/helpers';

import {CustomDatepickerModal} from './custom.datepicker.modal';

import picArrowLeft from "../../images/arrow-left.svg";
import picArrowRight from "../../images/arrow-right.svg";
import { CustomDatepickerHelpContext } from '../ChartWindow/components/help-context-customdatepicker';

dayjs.extend(objectSupport);
dayjs.locale(dayjsLocale);

const aggregates = [
    {'12H': '12 часов'},
    {'D': 'День'}, 
    {'E': 'Декада'}, 
    {'1M': 'Месяц'}, 
    {'A': 'Сезон'}, 
    {'Y': 'Год'}    
];

const _AGG = {
    '12H': '12H',
    'D': 'D',
    'E': 'E',
    '1M': '1M',
    'A': 'A',
    'Y': 'Y'
};


const periods = [
    {'D': 'День'}, 
    {'E': 'Декада'}, 
    {'1M': 'Месяц'}, 
    {'A': 'Сезон'}, 
    {'Y': 'Год'}    
]

const DEFAUILT_PERIOD_TYPE = 'D';
const DEFAULT_AGGREGATE_TYPE = 'D';

const aggregatesAcccess = {
    "D": ["12H", "D"],
    "E": ["12H", "D", "E"],
    "1M": ["12H", "D", "E", "1M"],
    "A": ["D", "E", "1M", "A"],
    "Y": ["E", "1M", "A", "Y"]
}

const monthes = dayjs.monthsShort().map(val => val.replace(/\./, ''));

export const CustomDatepicker = (
    {
        isCustom, 
        start, finish, 
        disabledStart, disabledFinish,
        chooseAggregate, choosePeriodType, isAggregate, 
        props,
        onStart, onAccept, onFinish, onAggregate, onClose,
        className
    }) => {

    const _RANGE_PICKER_FORMAT_DEFAULT = "DD.MM.YYYY HH:00";
    const _RANGE_PICKER_FORMAT_MINUTES = "DD.MM.YYYY HH:mm";    
    const _DATE_TIME_FORMAT = props?.format ? props.format : _RANGE_PICKER_FORMAT_DEFAULT;    
    const _TIME_FORMAT = props?.time_format ? props.time_format : "HH:00";

    const [ isShowModal, setIsShowModal ] = useState( false );

    const [ periodType, setPeriodType ] = useState ( DEFAUILT_PERIOD_TYPE );
    const [ aggregate, setAggregate ] = useState( DEFAULT_AGGREGATE_TYPE );
    const [ period, setPeriod ] = useState([]);
    const [ choosePeriod, setChoosePeriod ] = useState( [start, finish] );
    const [ rangePickerFormat, setRangePickerFormat] = useState(_RANGE_PICKER_FORMAT_DEFAULT );
    const [ isChangePeriodType, setIsChangePeriodType ] = useState( false );

    const [isShowHelpContext, setIsShowHelpContext ] = useState( false);
    

    useEffect(() => {
        setPeriod( [start, finish] );
    }, [start, finish] );

    useEffect(() => {
        if (isShowModal) {
            setAggregate( chooseAggregate ? chooseAggregate : DEFAULT_AGGREGATE_TYPE );                
            setPeriodType( choosePeriodType ? choosePeriodType : DEFAUILT_PERIOD_TYPE );
            setPeriod([...choosePeriod]);
        }            
    }, [isShowModal, choosePeriod]);

    const onInputClick = () => {
        setIsShowModal( true );        
    }

    const onCustomInputClick = () => {
        setIsChangePeriodType( true );
        setPeriodType('D');
    }

    const onHideModal = () => {
        setIsShowModal( false );
        setIsChangePeriodType( false );
    }

    const onChangePeriod = ( period ) => {
        setIsChangePeriodType( true ); 
        setAggregate( aggregatesAcccess[period][0] );       
        setPeriodType( period );
    }

    const onChangeAggregate = ( agg ) => {
        if (aggregatesAcccess[periodType].indexOf(agg) > -1) {
            setAggregate( agg );
            let fullAgg = DEFAULT_AGGREGATE_TYPE;

            if (_AGG.hasOwnProperty(agg))
                fullAgg = agg;

            if (typeof onAggregate != 'undefined')
                onAggregate( fullAgg );
        }
    }

    const onChoose = ( period ) => {
        setPeriod([
            period[0].toLocaleString(References.locale),
            period[1].toLocaleString(References.locale)
        ]);
    }

    const onAcceptClick = () => {
        setChoosePeriod([ period[0], period[1] ]);
        onHideModal();        

        onAccept( 
            period[0],            
            period[1],
            aggregate,
            periodType            
        );       


        if (typeof onClose === 'function')
            onClose();  
    }

    const onCloseHelpContext = () => {
        setIsShowHelpContext(false);
    }

    const onShowHelpContext = () => {
        setIsShowHelpContext(true)
    }

    return (
        <>
        {!isCustom ? 
        (
            <Space className={className}>
                <DatePicker
                showTime={{
                    minuteStep: 10,
                    format: _TIME_FORMAT
                }}
                defaultValue={dayjs(start, References.dateHourFormat)}                
                onChange={onStart}
                onOk={onStart}
                format={_DATE_TIME_FORMAT}
                locale={locale}
                changeOnBlur
                inputReadOnly
                allowClear={false}
                className="no-draggable"
                disabled={disabledStart}
                />

                <DatePicker
                showTime={{
                    minuteStep: 10,
                    format: _TIME_FORMAT
                }}
                defaultValue={dayjs(finish, References.dateHourFormat)}                
                value={dayjs(finish, References.dateHourFormat)}                
                onChange={onFinish}
                onOk={onFinish}
                format={_DATE_TIME_FORMAT}
                locale={locale}
                changeOnBlur
                inputReadOnly
                allowClear={false}
                className="no-draggable"
                disabled={disabledFinish}
                />            
            </Space>
        ) : 
        (
        <div>
            <div>
                <Space>
                    <Input name="start" onClick={onInputClick} readOnly value={ShowLocaleDate(dayjs(choosePeriod[0], References.dateFormat))}/>
                    <Input name="finish" onClick={onInputClick} readOnly value={ShowLocaleDate(dayjs(choosePeriod[1], References.dateFormat))}/>                    
                </Space>
            </div>
            { isShowModal && 
            <CustomDatepickerModal onClose={onHideModal} title="Выберите период" onShowHelpContext={onShowHelpContext} children={
                <>     
                {isShowHelpContext &&           
                    <CustomDatepickerHelpContext
                        onClose={onCloseHelpContext}
                    />
                }
                <div className="custom-datepicker-modal__wrap cdm d-flex flex-direct-column">
                    <div className="cdm__start-finish flex-shrink-0">
                        <input type="text" name="start" onClick={onCustomInputClick} readonly value={ShowLocaleDate(dayjs(period[0], References.dateFormat))}/>
                        <input type="text" name="finish" onClick={onCustomInputClick} readonly value={ShowLocaleDate(dayjs(period[1], References.dateFormat))}/>
                    </div>
                    <div className="cdm__body d-flex  flex-grow-1">
                        <div className="cdm__datepicker flex-grow-1">
                            {periodType === 'D' &&
                                <DatePickerDay period={period} isChangePeriodType={isChangePeriodType} onChoose={onChoose}/>
                            }
                            {periodType === 'E' &&
                                <DatePickerDecade choosePeriod={period} isChangePeriodType={isChangePeriodType} onChoose={onChoose}/>
                            }                  
                            {periodType ==='1M' &&
                                <DatePickerMonth  choosePeriod={period} isChangePeriodType={isChangePeriodType} onChoose={onChoose} />
                            }
                            {periodType === 'A' && 
                                <DatePickerSeason  choosePeriod={period} isChangePeriodType={isChangePeriodType} onChoose={onChoose} />
                            }
                            {periodType === 'Y' && 
                                <DatePickerYear choosePeriod={period} isChangePeriodType={isChangePeriodType} onChoose={onChoose} />
                            }

                        </div>
                        <div className="cdm__settings d-flex flex-shrink-0 pos-relative">
                            <div class="cdm__btn light cdm__accept" onClick={onAcceptClick }>Выбрать</div>                            
                            <div className="cdm__settings-period cdm__settings-col">
                            <div className="cdm__subtitle">Период<br />выборки</div>                                
                            {periods.map(val => {
                                let key = Object.keys( val )[0];
                                let label = val[key];
                                return (
                                    <div className={(periodType === key ? "primary" : "default") + " cdm__btn"} onClick={() => onChangePeriod(key)}>
                                        <div>{label}</div>
                                    </div>
                                );
                            })}

                            </div>
                            {isAggregate &&
                            <div className="cdm__settings-aggregate cdm__settings-col">
                            <div className="cdm__subtitle">Период<br />агрегации</div>
                            {aggregates.map(val => {
                                let key = Object.keys( val )[0];
                                let label = val[key];
                                return (
                                    <div className={(aggregate === key ? "primary" : "default") + " cdm__btn"} onClick={() => onChangeAggregate(key)} disabled={aggregatesAcccess[periodType].indexOf(key) == -1}>{label}</div>                                    
                                );
                            })}
                            </div>
                            }
                        </div>
                    </div>
                </div>

            </>
            }/>        
            }
        </div>        
        )
        }
        </>        
    );
}

const DayPanel = ({start, finish, month, year, onChooseMonth, onChooseDay}) => {

    const [ currMonth, setCurrMonth ] = useState( month );
    const [ currYear, setCurrYear ] = useState( year );
    const [ isSelected, setIsSelected ] = useState( false );

    useEffect(() => {
        setCurrMonth(month);
        setCurrYear(year);
    }, [ month, year ]);
    
    const onPrevMonthClick = () => {
        let prevMonth = dayjs({year: currYear, month: currMonth}).subtract( 1, 'month' );
        let month = prevMonth.month();
        let year = prevMonth.year();

        onChooseMonth( month, year );
    }

    const onNextMonthClick = () => {
        let nextMonth = dayjs({year: currYear, month: currMonth}).add( 1, 'month' );
        let month = nextMonth.month();
        let year = nextMonth.year();

        onChooseMonth( month, year );        
    }

    const onDayClick = (day, month, year, start, finish ) => {    
        let dayClickDate = dayjs({year: year, month: month, day: day});
        let period = [];
        //выбран день раньше периода        
        if (isSelected) {
            if (dayClickDate.isAfter(finish))   
                period = [start, dayClickDate];
            else  
                period = [dayClickDate, finish ];
            setIsSelected( false );
        } else {
            period = [dayClickDate, dayClickDate];
            setIsSelected( true );
        }
        onChooseDay(period[0], period[1]);
    }

    const days = ( month, year ) => {    
        let daysInMonth = dayjs({year: year, month: month}).daysInMonth();
        return Array(daysInMonth).fill().map((_, key) => key + 1);
    }

    const fillPrevMonthDays = () => {
        let dayOfWeek = dayjs({year: currYear, month: currMonth, day: 1}).weekday();
        let daysInPrevMonth = dayjs({year: currYear, month: currMonth}).subtract(1, 'month').daysInMonth();
        let prevMonthDate = dayjs({year: currYear, month: currMonth}).subtract(1, 'month');
        let month = prevMonthDate.month();
        let year = prevMonthDate.year();

        return Array(dayOfWeek).fill().map((_, key, arr) => {
            let day = daysInPrevMonth - (arr.length - 1) + key;
            return (
                <div 
                    className={getDayStatus(day, month, year, start, finish) + " custom-calendar-day-other"}
                    onClick={() => onDayClick(day, month, year, start, finish)}
                >{day}
                </div>
            )                
        })
    }

    const fillNextMonthDays = () => {
        let nextMonthFirstDay = dayjs({ year :currYear, month: currMonth + 1 , day :1}).weekday();
        let amount = (7 - nextMonthFirstDay);            
        let nextMonthDate = dayjs({year: currYear, month: currMonth}).add(1, 'month');
        let month = nextMonthDate.month();
        let year = nextMonthDate.year();


        return Array(amount).fill().map((_, key) => {
            return (
                <div 
                    className={getDayStatus(key + 1, month, year, start, finish) + " custom-calendar-day-other"}
                    onClick={() => onDayClick(key + 1, month, year, start, finish)}
                >{key + 1}
                </div>
            )                
        })
        
    }

    const fillDayOfWeekNames = () => {   
        let daysOfWeek = dayjs.weekdaysMin();                    
        return Array(7).fill().map((_, key) => {
            ++key;
            if ( key == 7)
                key = 0;
            return (<div className="custom-calendar-day-other">{daysOfWeek[key]}</div>)

        });
    }

    const getDayStatus = ( day, month, year, start, finish) => {
        let dateStart = dayjs(start?.startOf( 'day' ) - 1);
        let dateFinish = finish?.endOf('day');
        let date = dayjs({year: year, month: month, day: day});        
        return date.isAfter(dateStart) && date.isBefore(dateFinish) ? 'custom-calendar-day-choose' : null;
    }

    return (
        <div className="custom-calendar-wrap custom-calendar-wrap-days flex-grow-1">                        
        <div className="btn-arrow" onClick={onPrevMonthClick}><img src={picArrowLeft} /></div>                                    
        <div className="custom-calendar-day-days">                        
            {fillDayOfWeekNames()}
            {fillPrevMonthDays()}
            {days(currMonth, currYear).map((val) => {
                return (
                    <div 
                        key={`custom_date_picker_day_${val}_${currMonth}_${currYear}`}
                        className={getDayStatus(val, currMonth, currYear, start, finish)} 
                        onClick={() => onDayClick(val, currMonth, currYear, start, finish)}
                    >{val}
                    </div>
                );
            })}
            {fillNextMonthDays()}
        </div>
        <div class="btn-arrow" onClick={onNextMonthClick}><img src={picArrowRight} /></div>
    </div>

    )
}

const MonthPanel = ({start, finish, month, year, onChooseMonth}) => {

    const [ currMonth, setCurrMonth ] = useState( month );
    const [ currYear, setCurrYear] = useState( year );

    useEffect(() => {
        setCurrMonth( month );
        setCurrYear( year );
    }, [ month, year ]);

    const onChooseMonthClick = ( month ) => {
        onChooseMonth( month, currYear );
        setCurrMonth(month);
    }

    const onNextYearClick = () => {
        let year = currYear;
        setCurrYear(++year);
        onChooseMonth( currMonth, year );
    }

    const onPrevYearClick = () => {
        let year = currYear;
        setCurrYear(--year);
        onChooseMonth( currMonth, year );        
    }

    const getMonthStatus = (month, year, currMonth, start, finish) => {
        let result = new Array();

        //признак вхождения месяца в выбранный период - 
        let date = dayjs({year: year, month: month});
        let dateStart = start?.startOf( 'month' ) - 1;
        let dateFinish = finish?.endOf( 'month' );

        if (date.isAfter(dayjs(dateStart)) && date.isBefore(dateFinish))  
            result.push('primary');

        //признак отбражаемого месяца
        if (month === currMonth) 
            result.push("custom-calendar-curr-month");

        return result.join(' ');
    }  

    return (
        <>
            <div className="custom-calenday-day-monthes-wrapper">
                <div className="custom-calenday-day-monthes-year"  onClick={onPrevYearClick}>
                    <div class="btn-arrow mr-1"><img src={picArrowLeft} /></div>                                    
                    {currYear - 1}
                </div>
                <div className="custom-calendar-day-monthes">            
                    {new Array(12).fill().map((_, val) => {
                        return (
                            <div  key={"custom-calenday-day-month" + val} onClick={() => onChooseMonthClick(val)} 
                                className={getMonthStatus(val, currYear, currMonth, start, finish)}>
                                {monthes[val]}
                            </div>
                        );
                    })}
                </div>
                <div  className="custom-calenday-day-monthes-year"  onClick={onNextYearClick}>
                    {currYear + 1}
                    <div class="btn-arrow ml-1"><img src={picArrowRight} /></div>                
                </div>

            </div>
        </>
    )
}

const DatePickerDay = ({period, onChoose, isChangePeriodType}) => {

    const [ start, setStart ] = useState();
    const [ finish, setFinish ] = useState();
    const [ month, setMonth ] = useState();
    const [ year, setYear ] = useState();

    useEffect(() => {
        const choosePeriod = isChangePeriodType ? 
            [dayjs().startOf('day'), dayjs().startOf('day')] 
            : 
            [dayjs(period[0], References.dateFormat), dayjs(period[1], References.dateFormat)]; 

        const chooseStart = choosePeriod[0];
        const chooseFinish = choosePeriod[1];
        const chooseMonth = dayjs(choosePeriod[1], References.dateFormat).month();
        const chooseYear = dayjs(choosePeriod[1], References.dateFormat).year();

        setStart( chooseStart );
        setFinish( chooseFinish );
        setMonth( chooseMonth );
        setYear( chooseYear );

        onChooseNewPeriod(chooseStart, chooseFinish);
    }, []);

    const onChooseMonth = ( month, year ) => {
        setMonth(month);
        setYear(year);
    }

    const onChooseNewPeriod = (start, finish) => {
        setStart( start );
        setFinish( finish );
        onChoose([start.toDate(), finish.toDate()]);
    }
    
    return <>

        <MonthPanel 
            start={start}
            finish={finish}
            month={month}
            year={year}
            onChooseMonth={onChooseMonth}
        />

        <DayPanel 
            start={start}
            finish={finish}
            month={month}
            year={year}
            onChooseMonth={onChooseMonth}
            onChooseDay={onChooseNewPeriod}
        />


        </>;
}

const DatePickerDecade = ({choosePeriod, isChangePeriodType, onChoose}) => {

    const currDecade = GetDecade();
    const currMonth = new Date().getMonth();
    const currYear = new Date().getFullYear();

    const [ year, setYear ] = useState(0);
    const [ month, setMonth ] = useState(0);

    const [ period, setPeriod ]     = useState([]);
    const [ isSelected, setIsSelected ] = useState( false );

    useEffect(() => {

        let dayJSStart = dayjs(choosePeriod[0], References.dateFormat);
        let dayJSFinish = dayjs(choosePeriod[1], References.dateFormat);

        const startMonth = isChangePeriodType ? currMonth: dayJSStart.month();
        const startYear = isChangePeriodType ? currYear : dayJSStart.year();            
        const startDecade = isChangePeriodType ? currDecade : GetDecade(dayJSStart.date());
        
        const finishMonth = isChangePeriodType ? startMonth : dayJSFinish.month();
        const finishYear = isChangePeriodType ? startYear : dayJSFinish.year();          
        const finishDecade = isChangePeriodType ? startDecade :  GetDecade(dayJSFinish.date());

        let start = FormatDateByDecade(startDecade, startMonth, startYear, true);
        let finish = FormatDateByDecade(finishDecade, finishMonth, finishYear, false);
        setPeriod([start, finish]);
        onChoose([start, finish]);        

        setMonth( startMonth );
        setYear( startYear );

    }, []);

    const onPrevMonthClick = () => {
        let newMonth = GetStepMonth( month, -1 );
        let newYear = year;

        if ( newMonth > month )
            --newYear;

        setMonth( newMonth );
        setYear( newYear );
    }

    const onNextMonthClick = () => {
        let newMonth = GetStepMonth( month, 1 );
        let newYear = year;

        if ( newMonth < month )
            ++newYear;

        setMonth( newMonth );
        setYear( newYear );
    }

    const onClearClick = () => {
        setIsSelected( false );
        const start = FormatDateByDecade(currDecade, currMonth, currYear, true);
        const finish = FormatDateByDecade(currDecade, currMonth, currYear, true);
        setPeriod([start, finish]);
        onChoose([start, finish]);
    }

    const IsChooseDecade = ( decade, month, year ) => {
        let decadeDate = FormatDateByDecade(decade, month, year, true );
        return decadeDate >= period[0] && decadeDate <= period[1];
    }

    const ChooseDecade = (decade, month, year) => {
        //выьирается начальная (первая декада)
        let start = FormatDateByDecade(decade, month, year, true);        
        let finish = FormatDateByDecade(decade, month, year, false);                    
        if (!isSelected) {         
            setPeriod([start, finish]);
            setIsSelected( true );
            onChoose( [start, finish] );            
        } else {
            if (finish > period[1]) {                
                setPeriod( [ period[0], finish ] );
                onChoose( [ period[0], finish ] )
            }
            else {
                setPeriod( [ start, period[1] ] );
                onChoose( [ start, period[1] ] );
            }
            setIsSelected( false );
        }
    }


    return (
        <>
            { period ? (
                <div className="custom-calendar-manage">
                    <div className="custom-calendar-wrap">
                        <div class="btn-arrow" onClick={onPrevMonthClick}><img src={picArrowLeft} /></div>                                                
                        <div className="custom-calendar-decades">
                            <div>
                                <div className="custom-calendar-subtitle b">{monthes[GetStepMonth(month, -1)]}<br />{year}</div>
                                {[1, 2, 3].map((val) => {
                                    return (
                                        <div 
                                            key={year + (month - 1) + val} 
                                            onClick={() => ChooseDecade(val, month - 1, year)}
                                            className={(IsChooseDecade( val, month - 1, year ) ? 'primary' : 'default') + " custom-calendar-item"}                    
                                        >
                                            Декада {val}
                                        </div>
                                    );
                                })}
                            </div>
                            <div>
                                <div className="custom-calendar-subtitle b">{monthes[month]}<br />{year}</div>
                                {[1, 2, 3].map((val) => {
                                    return (
                                        <div 
                                            key={year + month + val} 
                                            onClick={() => ChooseDecade(val, month, year)}
                                            className={(IsChooseDecade( val, month, year ) ? 'primary' : 'default') + " custom-calendar-item"}                    
                                        >
                                            Декада {val}
                                        </div>
                                    );
                                })}
                            </div>                    
                        </div>
                        <div class="btn-arrow" onClick={onNextMonthClick}><img src={picArrowRight} /></div>                                                
                    </div>
                </div>
            ) : 
            (
                <div></div>
            ) 
            }
            <div className="mt-2"><a href="#" onClick={onClearClick} className="ml-2">очистить</a></div>
        </>
    );
}

const DatePickerMonth = ({choosePeriod, isChangePeriodType, onChoose}) => {

    const currMonth = dayjs().month() + 1;
    const currYear = dayjs().year();

    const [ year, setYear ] = useState(0);
    const [ month, setMonth ] = useState(0);

    const [ period, setPeriod ]     = useState([]);
    const [ isSelected, setIsSelected ] = useState( false );

    useEffect(() => {

        //если сменили период, то устанавливаем по текущей дате,
        //иначе устанавливаем из указанного в периоде (первое открытие календаря)
        const startMonth = isChangePeriodType ? currMonth: dayjs(choosePeriod[0], References.dateFormat).month() + 1;
        const startYear = isChangePeriodType ? currYear : dayjs(choosePeriod[0], References.dateFormat).year();            
        const finishMonth = isChangePeriodType ? startMonth : dayjs(choosePeriod[1], References.dateFormat).month() + 1;
        const finishYear = isChangePeriodType ? startYear : dayjs(choosePeriod[1], References.dateFormat).year();            

        let start = FormatDateByMonth(startMonth, startYear, true);
        let finish = FormatDateByMonth(finishMonth, finishYear, false);
        setPeriod([start, finish]);

        setMonth( startMonth );
        setYear( startYear );

        onChoose([start, finish]);        

    }, []);

    const onPrevYearClick = () => {
        let newYear = year;
        --newYear;
        setYear( newYear );
    }

    const onNextYearClick = () => {
        let newYear = year;
        ++newYear;
        setYear( newYear );
    }

    const IsChooseMonth = (month, year) => {
        let monthDate = FormatDateByMonth(month, year, true );
        return monthDate >= period[0] && monthDate <= period[1];

    }

    const ChooseMonth = ( month, year ) => {
        let start = FormatDateByMonth(month, year, true);        
        let finish = FormatDateByMonth(month, year, false);               

        if (!isSelected) {                                            
            setPeriod([start, finish]);
            setIsSelected( true );
            onChoose( [start, finish] );
        } else {
            if (finish > period[1]) {                
                setPeriod( [ period[0], finish ] );
                onChoose( [ period[0], finish ] )
            }
            else {
                setPeriod( [ start, period[1] ] );
                onChoose( [ start, period[1] ] );
            }
            setIsSelected( false );
        }

    }

    const onClearClick = () => {
        setIsSelected( false );
        const start = FormatDateByMonth(currMonth, currYear, true);
        const finish = FormatDateByMonth(currMonth, currYear, false);
        setPeriod([start, finish]);
        onChoose([start, finish]);
    }

    return (
        <>
            { period ? (
                <div className="custom-calendar-manage">  
                    <div className="custom-calendar-subtitle b">{year}</div>                                                               
                    <div className="custom-calendar-wrap">                        
                        <div class="btn-arrow" onClick={onPrevYearClick}><img src={picArrowLeft} /></div>                        
                        <div className="custom-calendar-monthes">                        
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((val) => {
                                return (
                                    <div 
                                        key={year + month + val} 
                                        className={IsChooseMonth( val, year ) ? 'primary' : 'default'} 
                                        onClick={() => ChooseMonth(val, year)}
                                    >
                                        {monthes[val - 1]}
                                </div>
                                );
                            })}
                        </div>
                        <div class="btn-arrow" onClick={onNextYearClick}><img src={picArrowRight} /></div>
                    </div>
                </div>

            ) : 
            (
                <div></div>
            ) 
            }
            <div className="mt-2"><a href="#" onClick={onClearClick} className="ml-2">очистить</a></div>
        </>
    );

}

const DatePickerSeason = ({choosePeriod, isChangePeriodType, onChoose}) => {
    const currSeason = GetSeason();
    const currYear = new Date().getFullYear();

    const [ year, setYear ] = useState(0);
    const [ season, setSeason ] = useState(0);

    const [ period, setPeriod ]     = useState([]);
    const [ isSelected, setIsSelected ] = useState( false );

    useEffect(() => {

        const dayJSStart = dayjs(choosePeriod[0],  References.dateFormat);
        const dayJSFinish = dayjs(choosePeriod[1],  References.dateFormat)

        const startSeason = isChangePeriodType ? currSeason: GetSeason(dayJSStart.toDate());
        const startYear = isChangePeriodType ? currYear : dayJSStart.year();            
        const finishSeason = isChangePeriodType ? startSeason : GetSeason(dayJSFinish.toDate());
        //с поправкой, что зима в следующем году
        const finishYear = isChangePeriodType ? startYear + ( currSeason === 1 ? 1 : 0) : dayJSFinish.year();            

        let start = FormatDateBySeason(startSeason, startYear, true, true);
        let finish = FormatDateBySeason(finishSeason, finishYear, false);

        setPeriod([start, finish]);
        onChoose([start, finish]);
        
        setSeason( finishSeason );
        setYear( startYear );        
    }, []);

    const onPrevYearClick = () => {
        let newYear = year;
        --newYear;
        setYear( newYear );
    }

    const onNextYearClick = () => {
        let newYear = year;
        ++newYear;
        setYear( newYear );
    }

    const IsChooseSeason = (season, year) => {
        let seasonDate = FormatDateBySeason(season, year, true );
        return seasonDate >= period[0] && seasonDate <= period[1];

    }

    const ChooseSeason = ( season, year ) => {
        let start = FormatDateBySeason(season, year, true);        
        let finish = FormatDateBySeason(season, year, false);                    
        if (!isSelected) {                                            
            setPeriod([start, finish]);
            setIsSelected( true );
            onChoose( [start, finish] );
        } else {
            if (finish > period[1]) {                
                setPeriod( [ period[0], finish ] );
                onChoose( [ period[0], finish ] )
            }
            else {
                setPeriod( [ start, period[1] ] );
                onChoose( [ start, period[1] ] );
            }
            setIsSelected( false );
        }
    }

    const onClearClick = () => {
        setIsSelected( false );
        const start = FormatDateBySeason(currSeason, currYear, true);
        const finish = FormatDateBySeason(currSeason, currYear, false);
        setPeriod([start, finish]);
        onChoose([start, finish]);        
    }

    return (
        <>
            { period &&
                <div className="custom-calendar-manage custom-calendar-season-wrapper">
                    <div class="btn-arrow" onClick={onPrevYearClick}><img src={picArrowLeft} /></div>                                                
                    <div>
                        <div className="custom-calendar-subtitle b mb-1">{year}</div>
                        <div className="custom-calendar-wrap">
                            <div className="custom-calendar-seasons">
                                {[1, 2, 3, 4].map((val) => {
                                    return (
                                        <div 
                                            key={year + val} 
                                            className={IsChooseSeason( val, year ) ? 'primary' : 'default'} 
                                            onClick={() => ChooseSeason(val, year)}
                                        >
                                            {References.seasons[val]}
                                        </div>
                                    );
                                })}
                            </div>                            
                        </div>
                    </div>
                    
                    <div>
                        <div className="custom-calendar-subtitle b mb-1">{year + 1}</div>
                        <div className="custom-calendar-wrap">
                            <div className="custom-calendar-seasons">
                                {[1, 2, 3, 4].map((val) => {
                                    return (
                                        <div 
                                            key={year + 1 + val} 
                                            className={IsChooseSeason( val, year + 1 ) ? 'primary' : 'default'} 
                                            onClick={() => ChooseSeason(val, year + 1)}
                                        >
                                            {References.seasons[val]}
                                        </div>
                                    );
                                })}
                            </div>                            
                        </div>
                    </div>
                    <div class="btn-arrow" onClick={onNextYearClick}><img src={picArrowRight} /></div>                                                                    
                </div>
            }
            <div className="mt-2"><a href="#" onClick={onClearClick} className="ml-2">очистить</a></div>
        </>
    );
}

const DatePickerYear = ({choosePeriod, isChangePeriodType, onChoose}) => {
    const currYear = new Date().getFullYear();

    const [ year, setYear ] = useState(0);

    const [ period, setPeriod ]     = useState([]);
    const [ isSelected, setIsSelected ] = useState( false );

    useEffect(() => {

        const dayJSStart = dayjs(choosePeriod[0],  References.dateFormat);
        const dayJSFinish = dayjs(choosePeriod[1],  References.dateFormat)

        const startYear = isChangePeriodType ? currYear : dayJSStart.year();            
        const finishYear = isChangePeriodType ? startYear : dayJSFinish.year();            

        let start = FormatDateByYear(startYear, true);
        let finish = FormatDateByYear(finishYear, false);
        setPeriod([start, finish]);
        onChoose([start, finish]);

        setYear( finishYear );

    }, []);

    const onPrevYearClick = () => {
        let newYear = year;
        --newYear;
        setYear( newYear );
    }

    const onNextYearClick = () => {
        let newYear = year;
        ++newYear;
        setYear( newYear );
    }

    const IsChooseYear = (year) => {
        let yearDate = FormatDateByYear(year, true );
        return yearDate >= period[0] && yearDate <= period[1];

    }

    const ChooseYear = ( year ) => {        
        let start = FormatDateByYear(year, true);        
        let finish = FormatDateByYear(year, false);                    
        if (!isSelected) {                                            
            setPeriod([start, finish]);
            setIsSelected( true );
            onChoose( [start, finish] );
        } else {
            if (finish > period[1]) {                
                setPeriod( [ period[0], finish ] );
                onChoose( [ period[0], finish ] )
            }
            else {
                setPeriod( [ start, period[1] ] );
                onChoose( [ start, period[1] ] );
            }
            setIsSelected( false );
        }
    }

    const onClearClick = () => {
        setIsSelected( false );
        const start = FormatDateByYear(currYear, true);
        const finish = FormatDateByYear(currYear, false);
        setPeriod([start, finish]);
        onChoose([start, finish]);                

    }

    return (
        <>
            { period &&
                <div className="custom-calendar-manage">
                    <div className="custom-calendar-wrap">
                        <div class="btn-arrow" onClick={onPrevYearClick}><img src={picArrowLeft} /></div>
                        <div className="custom-calendar-years">
                        {[5, 4, 3, 2, 1, 0].map(val => {
                            return (
                                    <div 
                                    key={year + val} 
                                    className={IsChooseYear( year - val) ? 'primary' : 'default'} 
                                    onClick={() => ChooseYear(year - val)}
                                >
                                    {year - val}
                                </div>
                            )

                        })}                            
                        </div>                                    
                        <div class="btn-arrow" onClick={onNextYearClick}><img src={picArrowRight} /></div>                        
                    </div>
                </div>
            }
            <div className="mt-2"><a href="#" onClick={onClearClick} className="ml-2">очистить</a></div>
        </>
    );}